import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import defaultLanguages from '../../../utils/helpers/defaultLanguage';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { NavBarOption } from './NavBarOption';
import NavBrand from './NavBrand';
import STATIC_NAV_LINKS from './staticNavLinks';
import './NavBar.css';

const NavBarPublic = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { tempedgeTranslator, locale: lang } = useTempEdgeTranslator();
  const { languages } = defaultLanguages();

  return (
    <header className="te-nav te-nav--glass" data-testid="navbar-public">
      <Container fluid="lg">
        <Row className="te-nav-inner align-items-center justify-content-between">
          <Col xs="auto" className="te-nav-left">
            <NavBrand to={`/home/${lang}`} testId="navbar-public-brand" />
          </Col>

          <Col xs="auto" className="te-nav-right">
            <ul className="te-nav-links">
              {STATIC_NAV_LINKS.map((link) => (
                <NavBarOption key={link.id} activePage={pathname} path={`${link.path}/${lang}`} label={link.labelKey} />
              ))}
            </ul>

            <LanguageSelector languages={languages} variant="pills" />

            {!pathname.includes('/signin') && (
              <button className="te-nav-signin" onClick={() => navigate(`/signin/${lang}`)} data-testid="navbar-public-signin">
                {tempedgeTranslator('com.tempedge.msg.label.sign_in')}
              </button>
            )}
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default NavBarPublic;
